import { connect } from 'react-redux';
import { actions } from "../../../../redux/modules/caja/caja";
import CajasEditar from './CajasEditar';


const ms2p = (state) => {
  return {
    ...state.caja,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CajasEditar);
